module.exports = __webpack_public_path__ + "media/images/es/prize-book-843c41ef0b72b6d439a50d43de228e64.png";